module.exports = __webpack_public_path__ + "static/media/9m.9b08a534.png";